$( document ).ready(function() {
  
  
  
    var price = $(this).parents('.itg_product_item').find('.itg_price').data('price');
    var pVaule = $(this).parents('.itg_product_item').find('input[name="quantity"]').val();
    var mainPrice = parseFloat(price * pVaule);
    var cur = $(this).parents('.itg_product_item').find('.total-price').data('currancy');
    $(this).parents('.itg_product_item').find('.total-price span').text(cur+' '+mainPrice+'.00');
  $("input").change(function(){
    var price = $(this).parents('.itg_product_item').find('.itg_price').data('price');
    var pVaule = $(this).parents('.itg_product_item').find('input[name="quantity"]').val();
    var mainPrice = parseFloat(price/100 * pVaule);
    var cur = $(this).parents('.itg_product_item').find('.total-price').data('currancy');
    $(this).parents('.itg_product_item').find('.total-price span').text(cur+' '+mainPrice+'.00');
//     console.log(mainPrice);
  });
  
  

  
  
  
  
  function myFunction(x) {
    if (x.matches) { // If media query matches
      const myTimeout = setTimeout(myTime, 3000);
      function myTime() {
        $('.itg_banner_pro').slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          autoplay: true,
          accesibility: false,
          draggable: false,
          swipe: false,
          touchMove: false,
          prevArrow:'<svg class="slick_arrows prev-arrow" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow"></path></svg>',
          nextArrow:'<svg class="slick_arrows next-arrow" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
        });
      }
    }
  }

var x = window.matchMedia("(max-width: 768px)")
myFunction(x) // Call listener function at run time
x.addListener(myFunction) // Attach listener function on state changes
  
});
